<template>
	<div class="container-fluid pb-3" style="padding-top: 80px; min-height: 100vh">
		<h1
			class="text-capitalize"
		>
			{{ $tc('faq', 2) }}
		</h1>
		<div
			class="d-flex justify-content-center align-items-center"
			style="flex-direction: column; min-height: calc(100vh - 152px)"
		>
			<img src="/images/faq.svg" height="200px">
			<h2>{{ $t('noFaq') }}</h2>
		</div>
	</div>
</template>

<script>
	export default {
		head () {
			return {
				title: `${this.merchant.business.name} | ${this.$tc('faq', 1)}`
			}
		},
		computed: {
			merchant () {
				return this.$store.state.merchant
			}
		}
	}
</script>

<style lang="css" scoped>
</style>
